import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'

import { IResponsibleUserTypes } from '../models'

const toDate = (value: string) => new Date(value)

export const getResponsibleUsers = ({
  SelectedPrimaryUser,
  SelectedBackupUser,
  BackupReserve,
  PrimaryReserve,
  OldBackupResponsibleUser,
  OldPrimaryResponsibleUser,
  ReservedPrimaryUserFrom,
  ReservedPrimaryUserTo,
  ReservedBackupUserFrom,
  ReservedBackupUserTo,
}: IAction): IResponsibleUserTypes => {
  const hasPrimaryReservedUser =
    Boolean(PrimaryReserve) && OldPrimaryResponsibleUser === SelectedPrimaryUser
  const hasBackupReservedUser =
    Boolean(BackupReserve) && OldBackupResponsibleUser === SelectedBackupUser
  return {
    primary: {
      email: hasPrimaryReservedUser ? PrimaryReserve || '' : SelectedPrimaryUser,
      isTempUser: hasPrimaryReservedUser,
      oldResponsibleUser: OldPrimaryResponsibleUser || undefined,
      reservedUserFrom: ReservedPrimaryUserFrom ? toDate(ReservedPrimaryUserFrom) : undefined,
      reservedUserTo: ReservedPrimaryUserTo ? toDate(ReservedPrimaryUserTo) : undefined,
    },
    backup: {
      email: hasBackupReservedUser ? BackupReserve || '' : SelectedBackupUser,
      isTempUser: hasBackupReservedUser,
      oldResponsibleUser: OldBackupResponsibleUser || undefined,
      reservedUserFrom: ReservedBackupUserFrom ? toDate(ReservedBackupUserFrom) : undefined,
      reservedUserTo: ReservedBackupUserTo ? toDate(ReservedBackupUserTo) : undefined,
    },
  }
}
